// Per-deployment branding, read from the runtime config file public/config.js
// (window.PROTRACK_CONFIG.brand) -- never compiled into the bundle, same as the
// API URL in cache.js. Defaults are deliberately neutral (no CodiFi branding),
// so a deployment whose config.js only sets apiUrl shows plain "ProTrack".
const raw = window.PROTRACK_CONFIG?.brand || {};
const str = (v) => String(v ?? "").trim();

export const BRAND = {
  orgName:      str(raw.orgName),                // e.g. "CodiFi"; "" = no org name shown
  orgWebsite:   str(raw.orgWebsite),             // shown on the login page, e.g. "codifi.in"
  productName:  str(raw.productName) || "ProTrack",
  logoUrl:      str(raw.logoUrl),                // sidebar logo; "" = text badge
  faviconUrl:   str(raw.faviconUrl),             // "" = the build's own /favicon.ico
  supportEmail: str(raw.supportEmail),
};

// "CodiFi ProTrack", or just "ProTrack" when no org name is configured.
export const APP_TITLE = [BRAND.orgName, BRAND.productName].filter(Boolean).join(" ");

// Label for the deployment's own (internal) side, as opposed to its customers.
export const ORG_LABEL = BRAND.orgName || "Internal";

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

// Called once from index.js before the first render.
export function applyBranding() {
  document.title = APP_TITLE;
  if (BRAND.faviconUrl) {
    setLink("icon", BRAND.faviconUrl);
    setLink("apple-touch-icon", BRAND.faviconUrl);
  }
}
